import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {MODULE, PageProps, PERMISSION} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {loc} from "core/common/config/locales";
import {ZzFlatButtonRoute} from "../../components/buttons/buttons";
import {PAGE} from "../../../routes";
import {PARAM_TABLE_LIST} from "../constants";

@observer
export default class ParamKeyList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = loc.i18n`Param key List`;
  static icon = 'key';
  static rootPage = true;
  static protectedPage = true;

  static fetchData(routerParams) {
    console.log("ParamKeyList#fetchData(%s)", PARAM_TABLE_LIST);

    return gridService.fetchGrids(PARAM_TABLE_LIST)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(PARAM_TABLE_LIST);
      });
  }

  render() {
    let {params, query} = this.props;

    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(PARAM_TABLE_LIST)}
                         entities={mdEntityService.entityMap}
                         gridId={params.gridId} query={query}>
        <ZzFlatButtonRoute onGridToolbar routeName="paramKeyDetail" params={{id: 'new'}}
                           label={loc.i18n`New param`} permission={PERMISSION.New} securable={PAGE.entityNumberGenGroupDetail}/>

      </GridCompConnected>
    );
  }

}



// WEBPACK FOOTER //
// ./src/core/tenant/paramkey/paramKeyList.tsx